import { MobileFundCard } from '../MobileFundCard'
import { FUTURE_SCHOLAR_529_PATH } from '../../../../components/FundDetails/Helpers/FundTypes.js'

export const FutureScholarPortfoliosMobile = ({
  funds,
  selectedPerformanceType,
  selectedSection,
  sortByAge,
}) => {
  return selectedSection === '#age-based-portfolios' ? (
    <div className="Accordion">
      <details className="Accordion-item" open>
        <summary className="Accordion-toggle Accordion--productGrouping u-bgColorSlateLight u-paddingVert2gu u-textNormal">
          Aggressive Track
        </summary>
        <div className="u-marginTop4gu">
          {funds
            .filter((fund) => fund.glidePath === 'AGGRESSIVE')
            .sort(sortByAge)
            .map((fund) => {
              return (
                <MobileFundCard
                  key={`${fund.cusip}_${fund.ageGroup}`}
                  fund={fund}
                  product={FUTURE_SCHOLAR_529_PATH}
                  section={selectedSection}
                  selectedPerformanceType529={selectedPerformanceType}
                />
              )
            })}
        </div>
      </details>
      <details className="Accordion-item" open>
        <summary className="Accordion-toggle Accordion--productGrouping u-bgColorSlateLight u-paddingVert2gu u-textNormal">
          Moderate Track
        </summary>
        <div className="u-marginTop4gu">
          {funds
            .filter((fund) => fund.glidePath === 'MODERATE')
            .sort(sortByAge)
            .map((fund) => {
              return (
                <MobileFundCard
                  key={fund.cusip}
                  fund={fund}
                  product={FUTURE_SCHOLAR_529_PATH}
                  section={selectedSection}
                  selectedPerformanceType529={selectedPerformanceType}
                />
              )
            })}
        </div>
      </details>
      <details className="Accordion-item" open>
        <summary className="Accordion-toggle Accordion--productGrouping u-bgColorSlateLight u-paddingVert2gu u-textNormal">
          Conservative Track
        </summary>
        <div className="u-marginTop4gu">
          {funds
            .filter((fund) => fund.glidePath === 'CONSERVATIVE')
            .sort(sortByAge)
            .map((fund) => {
              return (
                <MobileFundCard
                  key={`${fund.cusip}_${fund.ageGroup}`}
                  fund={fund}
                  product={FUTURE_SCHOLAR_529_PATH}
                  section={selectedSection}
                  selectedPerformanceType529={selectedPerformanceType}
                />
              )
            })}
        </div>
      </details>
    </div>
  ) : (
    <div className="Accordion">
      {funds.map((fund) => {
        return (
          <MobileFundCard
            key={fund.cusip}
            fund={fund}
            product={FUTURE_SCHOLAR_529_PATH}
            section={selectedSection}
            selectedPerformanceType529={selectedPerformanceType}
          />
        )
      })}
    </div>
  )
}
